/* eslint-disable react/no-array-index-key */
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import { Controller } from 'react-hook-form'
import ReactMarkdown from 'react-markdown'
import { useRefData } from '../../../hooks/data/useRefData'
import { setDirtyForm } from '../../../services/appPreferences/dirtyFormStorage'

// RHF focuses a field through its ref, but the RadioGroup root is not focusable
const resolveFocusTarget = container =>
  container?.querySelector('input[type="radio"]:checked') ??
  container?.querySelector('input[type="radio"]')

const RadioGroupWrapper = ({ control, formField, rules, readOnly }) => {
  const { refDataKey } = formField
  const hasDefaultOptions = Boolean(formField.defaultOptions?.length)
  const { data: refDataOptions } = useRefData(hasDefaultOptions ? undefined : refDataKey)
  const options = hasDefaultOptions ? formField.defaultOptions : refDataOptions

  const helperTextId = `${formField.name}-helper-text`

  return (
    options && (
      <Controller
        control={control}
        defaultValue={formField.defaultValue}
        name={formField.name}
        render={({ field, fieldState }) => {
          const hasHelperText = Boolean(fieldState.error || formField.helperText)
          return (
            <FormControl disabled={readOnly} error={Boolean(fieldState.error)} variant="outlined">
              <FormLabel id={formField.name}>
                <Typography variant="label">{formField.placeholder || formField.label}</Typography>
              </FormLabel>
              <RadioGroup
                ref={el => field.ref(el && { focus: () => resolveFocusTarget(el)?.focus() })}
                aria-describedby={hasHelperText ? helperTextId : undefined}
                aria-invalid={Boolean(fieldState.error)}
                aria-labelledby={formField.name}
                defaultValue={formField.defaultValue}
                name={formField.name}
                row={formField.direction === 'row'}
                value={field.value}
                onBlur={field.onBlur}
                onChange={(evt, value) => {
                  evt.preventDefault()
                  field.onChange(value)
                  if (!readOnly) setDirtyForm(true)
                }}
              >
                {options?.map(option => {
                  return (
                    <FormControlLabel
                      key={option.id ?? option.es_AR ?? option.label}
                      control={<Radio />}
                      label={option.es_AR ?? option.label}
                      value={option.id ?? option.value}
                    />
                  )
                })}
              </RadioGroup>
              {hasHelperText && (
                // ReactMarkdown emits a <p>, so the helper root must not be the default <p>
                <FormHelperText component="div" id={helperTextId}>
                  <ReactMarkdown>
                    {fieldState.error ? fieldState.error.message : formField.helperText}
                  </ReactMarkdown>
                </FormHelperText>
              )}
            </FormControl>
          )
        }}
        rules={rules}
      />
    )
  )
}

export default RadioGroupWrapper
